// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.leave-table[data-v-7f0fd252] {\n  width: 100%;\n}\n.leave-table[data-v-7f0fd252]  .cell {\n  padding: 0 6px;\n  white-space: normal;\n  word-break: break-word;\n  overflow-wrap: anywhere;\n}\n.leave-pagination[data-v-7f0fd252] {\n  margin-top: 16px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n", ""]);
// Exports
module.exports = exports;
